<template>
  <base-modal 
    :is-open="!!quest" 
    modal-class="quest-modal"
    data-cy="quest-modal"
    @close="$emit('close')"
  >
    <ion-content v-if="quest">
      
      <div class="p-lg text-center">
        <div class="text-[64px] text-success mb-lg">
          <ion-icon :icon="iconMap[quest.icon as keyof typeof iconMap] || trophyOutline"></ion-icon>
        </div>
        
        <h1 class="text-xl font-bold text-text-primary mb-sm" data-cy="quest-name">{{ quest.name }}</h1>
        <p class="text-base text-text-secondary mb-lg" data-cy="modal-quest-description">{{ quest.description }}</p>
        
        <div class="my-lg flex flex-col items-center gap-md">
          <h3 class="text-base font-semibold">{{ $t('rewards.progress') }}</h3>
          <ion-progress-bar 
            :value="getQuestProgress(quest)" 
            color="success"
            class="w-full h-2 my-xs"
            data-cy="modal-quest-progress-bar"
          ></ion-progress-bar>
          <p class="text-xs text-text-tertiary text-right w-full" data-cy="modal-quest-progress-text">
            {{ $t('rewards.questProgress', {
              progress: quest.tags?.progress || 0,
              target: quest.tags?.target || 0
            }) }}
          </p>
        </div>
        
        <div class="reward-container">
          <h3 class="text-base font-semibold">
            {{ $t('rewards.reward') }}
          </h3>
          <ion-badge color="success" class="text-base py-sm px-sm my-sm inline-block">
          +{{ quest.points_awarded }} {{ $t('common.points') }}
          </ion-badge>
          <p class="text-sm text-text-secondary">{{ $t('rewards.completeQuestToEarn') }}</p>
        </div>
      </div>

    </ion-content>
  </base-modal>
</template>

<script setup lang="ts">
import { IonContent, IonProgressBar, IonBadge } from '@ionic/vue';
import { trophyOutline } from 'ionicons/icons';
import BaseModal from './BaseModal.vue';
import type { Reward } from '../types';

interface Props {
  quest: Reward;
  getQuestProgress: (quest: Reward) => number;
  iconMap: Record<string, string>;
}

defineProps<Props>();
defineEmits<{
  close: [];
}>();
</script> 